import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const ThankYouPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0b0f] flex items-center justify-center p-4">
      <motion.div 
        className="glass p-12 max-w-2xl text-center"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <motion.div 
          className="w-20 h-20 mx-auto mb-8 rounded-full bg-neon-green/20 flex items-center justify-center"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
        >
          <CheckCircle className="w-10 h-10 text-neon-green" />
        </motion.div>

        <h1 className="text-4xl font-bold text-neon-green mb-4">Thank You!</h1>
        <p className="text-xl text-gray-400 mb-8">
          Your application for the LIFETRACK beta program has been received. We'll review your submission and get back to you soon.
        </p>

        <div className="space-y-4">
          <div className="glass p-4">
            <p className="text-sm text-gray-400">
              A confirmation email has been sent to your inbox. Please check your spam folder if you don't see it.
            </p>
          </div>

          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center space-x-2 px-6 py-3 bg-neon-green/20 text-neon-green rounded-lg hover:bg-neon-green/30 transition-colors"
          >
            <span>Return Home</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </motion.div>
    </div>
  );
};